import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger'
import reducer from './reducers';

let store;

if (window.DEBUG) {
    store = createStore(reducer, applyMiddleware(thunkMiddleware, createLogger()));
} else {
    store = createStore(reducer, applyMiddleware(thunkMiddleware));

}

export default store;